export function setHandoverString(key: string, value: string): void {
  sessionStorage.setItem(key, value)
}

export function getHandoverString(key: string): string {
  // 取得したらonetimeで消す
  const value = sessionStorage.getItem(key)
  sessionStorage.removeItem(key)
  if (value === null) {
    return ''
  }
  return value
}
